import { useEffect, useState } from 'react';
import config from '../config';
import { loadScript } from '../helpers/ExternalScript';

export const useLoadJPWidget = () => {
    const [isWidgetBundleLoaded, setIsWidgetBundleLoaded] = useState(false);
    const jpWidgetBundleUrl = config.get('jpWidgetBundleUrl');

    useEffect(() => {
        async function getJPWidgetScript() {
            await loadScript(jpWidgetBundleUrl);
            setIsWidgetBundleLoaded(true);
        }
        getJPWidgetScript();
    }, [jpWidgetBundleUrl]);

    return { isWidgetBundleLoaded };
};



// WEBPACK FOOTER //
// ./src/hooks/useLoadJPWidget.js